import { render, staticRenderFns } from "./ViewTodo.vue?vue&type=template&id=4f60f838&scoped=true&"
import script from "./ViewTodo.vue?vue&type=script&lang=js&"
export * from "./ViewTodo.vue?vue&type=script&lang=js&"
import style0 from "./ViewTodo.vue?vue&type=style&index=0&id=4f60f838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60f838",
  null
  
)

export default component.exports